// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { useParams } from 'react-router-dom';
import { useProject } from 'hooks/projects/queries';
import Header from './Header';

function ProjectHeader() {
  const { projectID } = useParams();
  const projectId = projectID;
  const { data: project } = useProject(projectId);

  return (
    <Header>{project?.name || ''}</Header>
  );
}

export default ProjectHeader;
